<template>
  <div class="shopLists">
    <div class="listGrid">
      <button type="button" class="item addItem"
        @click="openCreateShop"></button>
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="{isBaseShopPos: item.isBaseShopPos}"
        class="item"
        @click="setDetail(item.pageId)">
        <div
          class="name">
          {{ item.pageName }}
        </div>
        <div class="info">
          <p>{{ locale.table_updateat }}: {{ dateFormat(item.updateat) }}</p>
          <p>{{ locale.table_createat }}: {{ dateFormat(item.createat) }}</p>
        </div>
      </div>
    </div>
    <CreateShop
      v-if="createShop"
      :locale="locale"
      :canDuplicate="canDuplicate"
      @create="createShopPage"
      @duplicate="duplicateShopPage"
      @close="closeCreateShop" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DATE from '@/common/date'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import CreateShop from './CreateShop'

export default {
  name: 'ShopList',
  props: [
    'locale'
  ],
  components: {
    CreateShop
  },
  computed: {
    canDuplicate () {
      return this.list.length > 0
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      list: [],
      createBy: null,
      integrationList: [],
      createShop: false,
      message: null
    }
  },
  methods: {
    async init () {
      this.$store.commit('onLoading', true)
      await this.getShopPageList()
      this.$store.commit('onLoading', false)
    },
    async getShopPageList () {
      const shopList = await this.$store.dispatch('shop/getShopPageList')
      const pageList = shopList && shopList.message && shopList.message.pageList
      if (pageList) {
        this.list = pageList
      }
      return shopList
    },
    dateFormat (isoString) {
      return DATE.toString(isoString)
    },
    setDetail (id) {
      this.$router.push({
        name: 'shopPage',
        ...(id && id !== 'new') && {
          params: {
            id: id
          }
        }
      })
    },
    openCreateShop () {
      this.createShop = true
    },
    closeCreateShop () {
      this.createShop = false
    },
    async duplicateShopPage (data) {
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('shop/copyShopPage', data)
      const pageId = res && res.message && res.message.pageId
      if (pageId) {
        this.setDetail(pageId)
      }
      await this.getShopPageList()
      this.$store.commit('onLoading', false)
    },
    async createShopPage (data) {
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('shop/initShopServicePage', data)
      const pageId = res && res.message && res.message.pageId
      if (pageId) {
        this.setDetail(pageId)
      }
      await this.getShopPageList()
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.createBy {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.3;
  background-color: rgba(0,0,0,0.5);
  z-index: 9;
  ul {
    display: flex;
    align-items: center;
    text-align: center;
    width: 800px;
    min-height: 160px;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      align-self: stretch;
      padding: 30px;
      border-radius: 4px;
      background-color: $color-white;
      box-shadow: 0 0 10px rgba(0,0,0,0.2);
      cursor: pointer;
      & + li {
        margin-left: 30px;
      }
    }
  }
}
</style>
